import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Reveal } from "@/components/Reveal";

const COLLECTIONS = [
  {
    name: "Furniture",
    note: "Sofas, chairs, tables",
    image: "https://images.unsplash.com/photo-1555041469-a586c61ea9bc?q=80&w=900&auto=format&fit=crop",
  },
    {
    name: "Lighting",
    note: "Lamps for low, warm light",
    image: "https://images.unsplash.com/photo-1615873968403-89e068629265?q=80&w=900&auto=format&fit=crop",
  },
  {
    name: "Decor",
    note: "Vases and objects",
    image: "https://images.pexels.com/photos/17619624/pexels-photo-17619624.jpeg?auto=compress&cs=tinysrgb&w=900",
  },
  {
    name: "Kitchen",
    note: "Pantry, storage & tools",
    image: "https://cf.cjdropshipping.com/17664480/b80c66e0-449c-45cc-9b73-413cb0075aed.jpg",
  },
  {
    name: "Home Safety",
    note: "Baby & child protection",
    image: "https://cf.cjdropshipping.com/384dd0e0-4ef2-439e-a142-05b3699abb14.png",
  },
];

export const Collections = () => (
  <section id="collections" data-testid="collections-section" className="mx-auto max-w-[1600px] px-6 py-24 sm:px-10 sm:py-32">
    <Reveal>
      <p className="mb-4 text-xs uppercase tracking-[0.3em] text-taupe">Browse by room & mood</p>
      <h2 className="mb-16 font-serif text-3xl font-light tracking-tight sm:text-4xl lg:text-5xl">Collections</h2>
    </Reveal>
    <div className="grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-5">
      {COLLECTIONS.map((c, i) => (
        <Reveal key={c.name} delay={i * 0.08}>
          <Link
            to={`/shop?category=${c.name}`}
            data-testid={`collection-${c.name.toLowerCase()}`}
            className="group block"
          >
            <div className="flex aspect-[4/5] items-center justify-center overflow-hidden bg-sand p-6">
              <img
                src={c.image}
                alt={c.name}
                loading="lazy"
                className="max-h-full max-w-full object-contain transition-transform duration-700 ease-out group-hover:scale-105"
              />
            </div>
            <div className="mt-4 flex items-center justify-between">
              <div>
                <h3 className="font-serif text-xl tracking-tight">{c.name}</h3>
                <p className="mt-1 text-xs uppercase tracking-[0.2em] text-ash">{c.note}</p>
              </div>
              <ArrowUpRight size={18} className="text-ash transition-all duration-300 group-hover:-translate-y-1 group-hover:translate-x-1 group-hover:text-charcoal" />
            </div>
          </Link>
        </Reveal>
      ))}
    </div>
  </section>
);
